import "../team/styles.sass";

import React, { FC, useContext, useEffect, useState } from "react";
import { observer } from "mobx-react-lite";
import { Context } from "../../..";
import Emptiness from "../../../components/UI/emptiness/Emptiness";
import Timofey from "../../../assets/images/Timofey_avatar.png";
import Spinner from "../../../components/UI/spinner/Spinner";
// import ContactUs from "./blocks/ContactUs";
import { IBlocks, IContent, IHeader } from "../../../models/IPages";
import {
  createFileFromBase64,
  getImageExtensionFromBase64,
  removeKeyFromObject,
} from "../../../utils";
import PrivacyPolicyBlock from "./blocks/PrivacyPolicyBlock";

const PrivacyPolicy: FC = () => {
  const { pages, store, roles } = useContext(Context);

  const categoryType = window.location.pathname.split("/").pop() || "";

  const [privacyPolicy, setPrivacyPolicy] = React.useState<string>("");
  const [adminPermissionData, setAdminPermissionData] = useState<any>()

  useEffect(() => {
    pages
      .loadList(categoryType)
      .then((res: any) => {
        handleFillData(res.content);
      })
      .catch(console.log);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pages]);

  const handleSave = (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    const formData = new FormData();


    [
      privacyPolicy,
     ].forEach((object, index) => {
      // remove base64 images from object
      const filteredObject = removeKeyFromObject(object, "images");
      // Convert object data to JSON string
      const objectData = JSON.stringify(filteredObject);
      const objectKey = Object.keys({
        privacyPolicy,
      })[index];

      formData.append(objectKey, objectData);
    });

    pages
      .updateOne(categoryType, formData)
      .then(() => {
        pages
          .loadList(categoryType)
          .then((res: any) => {
            handleFillData(res.content);
          })
          .catch(console.log);
      })
      .catch(console.log);
  };

  const handleFillData = (content: any) => {
    if (content) {
      setPrivacyPolicy(content[2].privacyPolicy);
      }
  };

  useEffect(() => {
    loadNewData()
  }, [])

  const loadNewData = async () => {
    const userData = store?.user?.role?.find((par: any) => par?.path === "pages")?.children?.find((child: any) => child.path === "privacyPolicy")
    setAdminPermissionData(userData)
  };

  return (
    <div className="PrivacyPolicy-page">
      {Object.keys(pages.pageContent).length > 0 &&
      !pages.loadingContentBool ? (
        <form className="body" onSubmit={handleSave}>
          {/* TODO: info block applied   */}
          <PrivacyPolicyBlock
            data={privacyPolicy}
            setData={setPrivacyPolicy}
            categoryType={categoryType}
            actionData = {adminPermissionData}
          />
          {/* <div className="btn-container">
            <Button className="button" label="Save" type="submit" />
          </div> */}
        </form>
      ) : Object.keys(pages.pageContent).length === 0 &&
        !pages.loadingContentBool ? (
        <Emptiness icon={Timofey} content="It's time to create some content!" />
      ) : (
        <div className="spinner-container">
          <Spinner />
        </div>
      )}
    </div>
  );
};

export default observer(PrivacyPolicy);
